import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "top",
  class: "hero shell"
}
const _hoisted_2 = { class: "hero-media" }
const _hoisted_3 = ["poster"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "method",
  class: "method shell"
}
const _hoisted_6 = { class: "pipeline" }
const _hoisted_7 = { class: "frame" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "frame" }
const _hoisted_10 = {
  ref: "generatedVideo",
  autoplay: "",
  muted: "",
  loop: "",
  playsinline: "",
  preload: "metadata"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "frame" }
const _hoisted_13 = {
  ref: "optimizationVideo",
  autoplay: "",
  muted: "",
  loop: "",
  playsinline: "",
  preload: "metadata"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "method-note" }
const _hoisted_16 = {
  ref: "methodProgress",
  class: "progress"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WhyPlateau = _resolveComponent("WhyPlateau")!
  const _component_ResultsExplorer = _resolveComponent("ResultsExplorer")!

  return (_openBlock(), _createElementBlock("main", null, [
    _cache[19] || (_cache[19] = _createStaticVNode("<nav class=\"nav shell\" data-v-25a4d40c><div class=\"nav-links\" data-v-25a4d40c><a href=\"#why\" data-v-25a4d40c>Why</a><a href=\"#method\" data-v-25a4d40c>Method</a><a href=\"#results\" data-v-25a4d40c>Results</a><a class=\"nav-resource\" href=\"https://drive.google.com/file/d/17vgjkiFfhvLbxQX7zaqCbsKd08whSiRI/view?usp=drive_link\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Paper ↗</a><a class=\"nav-resource\" href=\"https://github.com/SuikaSibyl/vnc\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Code ↗</a></div></nav>", 1)),
    _createElementVNode("header", _hoisted_1, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"hero-copy\" data-v-25a4d40c><p class=\"eyebrow\" data-v-25a4d40c><span data-v-25a4d40c></span>SIGGRAPH Asia 2026</p><h1 data-v-25a4d40c>Video Numerical Continuation <em data-v-25a4d40c>for Differentiable Inverse Rendering</em></h1><div class=\"author\" data-v-25a4d40c><div class=\"author-list\" data-v-25a4d40c><a href=\"https://suikasibyl.github.io/\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Haolin Lu</a><a href=\"https://ishit.github.io/\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Ishit Mehta</a><a href=\"https://haodong2000.github.io/\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Haodong Li</a><span data-v-25a4d40c>Yu Fu</span><a href=\"https://cseweb.ucsd.edu/~tzli/\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Tzu-Mao Li</a><a href=\"https://cseweb.ucsd.edu/~ravir/\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Ravi Ramamoorthi</a></div><p class=\"author-affiliation\" data-v-25a4d40c>University of California San Diego</p></div><p class=\"dek\" data-v-25a4d40c>Video Foundation Models Guide Inverse Rendering to Convergence.</p><div class=\"actions\" data-v-25a4d40c><a class=\"button primary\" href=\"https://drive.google.com/file/d/17vgjkiFfhvLbxQX7zaqCbsKd08whSiRI/view?usp=drive_link\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Paper <b data-v-25a4d40c>↗</b></a><a class=\"button secondary\" href=\"https://github.com/SuikaSibyl/vnc\" target=\"_blank\" rel=\"noopener\" data-v-25a4d40c>Code <b data-v-25a4d40c>↗</b></a><a class=\"button secondary\" href=\"#results\" data-v-25a4d40c>Results <b data-v-25a4d40c>↓</b></a></div></div>", 1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "media-label" }, [
          _createElementVNode("b", null, "01"),
          _createElementVNode("span", null, "Generated continuation path")
        ], -1)),
        _createElementVNode("video", {
          autoplay: "",
          muted: "",
          loop: "",
          playsinline: "",
          preload: "metadata",
          poster: _ctx.media('house-target.png')
        }, [
          _createElementVNode("source", {
            src: _ctx.media('house.mp4'),
            type: "video/mp4"
          }, null, 8, _hoisted_4)
        ], 8, _hoisted_3),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "corner corner-a" }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "corner corner-b" }, null, -1))
      ])
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("section", {
      id: "abstract",
      class: "abstract-section"
    }, [
      _createElementVNode("div", { class: "shell split-heading" }, [
        _createElementVNode("div", null, [
          _createElementVNode("p", { class: "kicker" }, "Abstract"),
          _createElementVNode("h2", null, "Turn one hard objective into a path of simple ones.")
        ]),
        _createElementVNode("p", null, " Differentiable rendering enables gradient-based scene parameter recovery, but its objectives are highly non-convex and prone to poor local minima. Given initial and target images, we synthesize a smooth video trajectory and optimize scene parameters sequentially across its frames. This numerical continuation guides parameters along a tractable path and enables convergence from challenging initializations where standard methods stall. ")
      ])
    ], -1)),
    _createVNode(_component_WhyPlateau),
    _createElementVNode("section", _hoisted_5, [
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "section-heading" }, [
        _createElementVNode("p", { class: "kicker" }, "Method"),
        _createElementVNode("h2", null, "Guiding the optimization with a generated video.")
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("article", null, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "step" }, "01", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _ctx.media('house-init.png'),
              alt: "Initial scene configuration"
            }, null, 8, _hoisted_8)
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Render the initialization", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", null, "Start with parameters that may be far from the desired solution.", -1))
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "arrow" }, "→", -1)),
        _createElementVNode("article", null, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "step" }, "02", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("video", _hoisted_10, [
              _createElementVNode("source", {
                src: _ctx.media('house.mp4'),
                type: "video/mp4"
              }, null, 8, _hoisted_11)
            ], 512)
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Generate a trajectory", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("p", null, "Condition a video model on the first and last frames to infer intermediate states.", -1))
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "arrow" }, "→", -1)),
        _createElementVNode("article", null, [
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "step" }, "03", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("video", _hoisted_13, [
              _createElementVNode("source", {
                src: _ctx.resultMedia('resources/pose/house/vnc.mp4'),
                type: "video/mp4"
              }, null, 8, _hoisted_14)
            ], 512)
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Follow and converge", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("p", null, "Optimize through the scheduled references and watch the rendered pose converge.", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[16] || (_cache[16] = _createElementVNode("span", null, "λ = 0", -1)),
        _createElementVNode("div", _hoisted_16, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("i", null, null, -1)
        ]))], 512),
        _cache[17] || (_cache[17] = _createElementVNode("span", null, "λ = 1", -1))
      ])
    ]),
    _createVNode(_component_ResultsExplorer)
  ]))
}